import { getGlobalConfig } from "src/datahandling/redux/globalConfig";
import { getAccessToken } from "src/authentication-and-logging/authAndLogger";

const SIGNALR_HUB = "uniteaq";

interface SubscriptionRequest {
	hub: string;
	groupNames: string[];
	connectionId: string;
}

async function signalrGroupsCall(groupNames: string[], connectionId: string, endpoint: string): Promise<boolean> {
	const config = getGlobalConfig();
	const signalRUrl = config?.API_BASE_URLS?.SIGNALR_MANAGER;
	const token = await getAccessToken();

	if (!signalRUrl || !token) {
		console.error("[SignalR API] Missing URL or token");
		return false;
	}

	const body: SubscriptionRequest = {
		hub: SIGNALR_HUB,
		groupNames,
		connectionId,
	};

	try {
		const response = await fetch(`${signalRUrl}/connections/${endpoint}`, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(body),
		});

		if (response.ok) {
			return true;
		}

		console.error(`[SignalR API] ${endpoint} failed:`, response.status);
		return false;
	} catch (error) {
		console.error(`[SignalR API] ${endpoint} error:`, error);
		return false;
	}
}

export async function addToGroups(groupNames: string[], connectionId: string): Promise<boolean> {
	return await signalrGroupsCall(groupNames, connectionId, "add-to-groups");
}

export async function removeFromGroups(groupNames: string[], connectionId: string): Promise<boolean> {
	return await signalrGroupsCall(groupNames, connectionId, "remove-from-groups");
}
